import { useMemo, useState } from 'react';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import cross from '~/assets/icons/cross.svg';
import { CollectionImage } from '~/components/collections';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { FadeContainer } from '~/components/ui/FadeContainer';
import { Text } from '~/components/ui/Text';
import realtyExample from '../../assets/images/realty_example.jpg';
import {
	setAuctionCategorySelectVisible,
	setAuctionCreateVisible,
	setAuctionItemSelectVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAuctionTypes } from '../AppAuction/AppAuction.model';
import { VehiclePlateBig } from '../VehiclePlateBig';
import {
	auctionClothesPreviewItems,
	auctionItemSelectTitle,
} from './AppAuctionItemSelect.model';
import {
	StyledClothesCard,
	StyledClothesHeadline,
	StyledClothesImageSlot,
	StyledCollectionImageContainer,
	StyledContainer,
	StyledContinueWrap,
	StyledHeadBackSlot,
	StyledHeadContainer,
	StyledHeadCrossSlot,
	StyledItemsGrid,
	StyledPlateContainer,
	StyledPreviewCard,
	StyledPreviewImageWrap,
	StyledVehicleContainer,
} from './AppAuctionItemSelect.styled';

const AppAuctionItemSelect = () => {
	const dispatch = useLayoutDispatch();
	const createCategory = useLayoutSelector(
		(state) => state.auction.createCategory,
	);
	const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

	const buttonActive = useMemo(() => selectedIndex !== null, [selectedIndex]);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<StyledHeadBackSlot>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						borderRadius={ButtonBorderRadius.Radius10}
						onClick={() => {
							dispatch(setAuctionItemSelectVisible(false));
							dispatch(setAuctionCategorySelectVisible(true));
						}}
						style={{
							width: 'auto',
							padding: '0 10px',
							gap: 10,
							justifyContent: 'flex-start',
							fontSize: 14,
						}}
					>
						<img src={arrowLeft} />
						<Text>Вернуться назад</Text>
					</Button>
				</StyledHeadBackSlot>
				<Text
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
					}}
				>
					{auctionItemSelectTitle[createCategory]}
				</Text>
				<StyledHeadCrossSlot>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						borderRadius={ButtonBorderRadius.Radius10}
						square
						onClick={() => dispatch(setAuctionItemSelectVisible(false))}
					>
						<img width={14} height={14} src={cross} />
					</Button>
				</StyledHeadCrossSlot>
			</StyledHeadContainer>
			<FadeContainer
				height={515}
				fadeSize={100}
				style={{ width: 740, margin: '0 auto' }}
			>
				<StyledItemsGrid>
					{createCategory === AppAuctionTypes.Realty &&
						new Array(12).fill(0).map((_, index) => (
							<StyledPreviewCard
								$active={selectedIndex === index}
								key={index}
								onClick={() => setSelectedIndex(index)}
							>
								<StyledPreviewImageWrap>
									<img src={realtyExample} alt="" />
								</StyledPreviewImageWrap>
								<Text>Квартира №{(index + 1) * 10}</Text>
							</StyledPreviewCard>
						))}
					{createCategory === AppAuctionTypes.Vehicle &&
						new Array(12).fill(0).map((_, index) => (
							<StyledVehicleContainer
								$active={selectedIndex === index}
								key={index}
								onClick={() => setSelectedIndex(index)}
							>
								<Text>BMW M5 F90</Text>
								<StyledCollectionImageContainer>
									<CollectionImage
										collection={'vehicles'}
										size={81}
										id={'gaz_2410'}
									/>
								</StyledCollectionImageContainer>
								<StyledPlateContainer>
									<VehiclePlateBig number={'О744ОО'} region={'38'} />
								</StyledPlateContainer>
							</StyledVehicleContainer>
						))}
					{createCategory === AppAuctionTypes.Clothes &&
						auctionClothesPreviewItems.map((item, index) => (
							<StyledClothesCard
								$active={selectedIndex === index}
								key={item.id}
								onClick={() => setSelectedIndex(index)}
							>
								<StyledClothesHeadline>
									{item.name} <span>{item.variant}</span>
								</StyledClothesHeadline>
								<StyledClothesImageSlot>
									<CollectionImage
										collection={'clothes'}
										id={item.id as never}
										size={140}
									/>
								</StyledClothesImageSlot>
							</StyledClothesCard>
						))}
					{createCategory === AppAuctionTypes.Bussiness &&
						new Array(12).fill(0).map((_, index) => (
							<StyledPreviewCard
								$active={selectedIndex === index}
								key={index}
								onClick={() => setSelectedIndex(index)}
							>
								<StyledPreviewImageWrap>
									<img src={realtyExample} alt="" />
								</StyledPreviewImageWrap>
								<Text>Бизнес №{index + 1}</Text>
							</StyledPreviewCard>
						))}
				</StyledItemsGrid>
			</FadeContainer>
			<StyledContinueWrap>
				<Button
					color={ButtonColors.Select2}
					height={ButtonHeight.Height40}
					borderRadius={ButtonBorderRadius.Radius10}
					disabled={!buttonActive}
					onClick={() => {
						dispatch(setAuctionItemSelectVisible(false));
						dispatch(setAuctionCreateVisible(true));
					}}
					style={{
						minWidth: 120,
					}}
				>
					<Text style={{ fontSize: 14 }}>
						{buttonActive
							? 'Продолжить'
							: auctionItemSelectTitle[createCategory]}
					</Text>
				</Button>
			</StyledContinueWrap>
		</StyledContainer>
	);
};

export { AppAuctionItemSelect };
